<template>
  <el-dialog
    :visible="visible"
    width="70%"
    top="5vh"
    class="add-task-modal"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <el-row slot="title">
      <h2>СОЗДАНИЕ ЗАДАНИЯ</h2>
    </el-row>
    <el-form
      ref="addTaskForm"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <el-form-item prop="type" label="Тип задания:">
        <el-select v-model="formData.type" placeholder="Выберите из списка">
          <el-option
            v-for="(task, i) in taskTypes"
            :key="i"
            :label="task"
            :value="i"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="description" label="Описание:">
        <el-input v-model="formData.description" :rows="5" type="textarea" />
      </el-form-item>
      <el-form-item prop="user_id" label="Кому назначена:">
        <admin-select
          :id="formData.user_id"
          custom-class="cc-admin-loader"
          @change="onChange"
        />
      </el-form-item>
      <el-row class="btn-block">
        <el-button type="primary" :loading="loading" @click="onSave">
          Сохранить
        </el-button>
      </el-row>
    </el-form>
    <success-modal :visible="success" @finish="onClose" @next="toAddContacts" />
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { UPDATE_TASK } from '@/store/actions/callCenter'
import { mapMutations } from 'vuex'
import { taskTypes } from '@/views/CallCenter/constants'
import AdminSelect from '../AdminSelect'
import SuccessModal from './SuccessModal'

const CallCenter = RepositoryFactory.get('callCenter')

export default {
  name: 'AddTaskModal',
  components: { SuccessModal, AdminSelect },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        type: '',
        description: '',
        user_id: null,
      },
      rules: {
        type: { required: true, message: 'Выберите тип', trigger: 'blur' },
        description: {
          required: true,
          message: 'Добавьте описание',
          trigger: 'blur',
        },
        user_id: {
          required: true,
          message: 'Выберите исполнителя',
          trigger: 'blur',
        },
      },
      loading: false,
      success: false,
      taskTypes,
      id: 0,
    }
  },
  methods: {
    ...mapMutations({ updateTask: `callCenter/${UPDATE_TASK}` }),
    toAddContacts() {
      this.onClose()
      this.$emit('set', 'addContactModal', this.id)
    },
    onChange(val) {
      this.formData.user_id = val
    },
    onSave() {
      this.$refs['addTaskForm'].validate(valid => {
        if (valid) {
          this.loading = true
          CallCenter.postTask(this.formData)
            .then(res => {
              const { data, status } = res

              if (status === 201 && data) {
                this.updateTask(data)
                this.id = data.id
                this.success = true
              }
            })
            .catch(err => this.errHandler(err))
            .finally(() => (this.loading = false))
        }
      })
    },
    onClose() {
      this.success = false
      this.$emit('close')
      this.formData = {
        types: '',
        description: '',
        user_id: null,
      }
    },
  },
}
</script>

<style lang="sass">
.add-task-modal
  h2
    margin: 30px
    font-weight: bold
    font-size: 18px
    line-height: 17px
  .el-dialog__headerbtn
    top: 50px
    right: 50px
    font-size: 18px
  .el-dialog__body
    padding: 0 50px 50px
    .el-form-item__label
      font-size: 16px
      line-height: 17px
      color: #000
    .el-select
      width: 320px
    .el-input__inner, .el-textarea__inner, .el-button
      font-size: 16px
      font-family: Rubik, sans-serif
      font-weight: normal
    .btn-block
      margin-top: 50px
      button
        width: 200px
        height: 47px
  .cc-admin-loader
    width: 320px
</style>
